module.exports = __webpack_public_path__ + "media/images/nav-logo-prando-4a91de76cde4ee16d905ed0adeba11a8.png";